module.exports = __webpack_public_path__ + "images/facebook.81e7f8ec11c6a8501cf541e20a0906e1.svg";